<script setup lang="ts">
import * as uiLocales from '@nuxt/ui/locale'

const runtimeConfig = useRuntimeConfig()
if (runtimeConfig.public.SITE_ENV === 'master') {
  useSeoMeta({ robots: 'noindex, nofollow' })
}

useSeoMeta({
  ogImage: DEFAULT_OG_IMAGE,
  twitterCard: 'summary_large_image',
  twitterImage: DEFAULT_OG_IMAGE
})

// Idioma
const { locale } = useI18n()

// Obtener el locale de Nuxt UI según el locale de i18n
const uiLocale = computed(() => {
  const localeMap: Record<string, (typeof uiLocales)['es']> = {
    'es': uiLocales.es,
    'en': uiLocales.en,
    'de': uiLocales.de,
    'it': uiLocales.it,
    'fr': uiLocales.fr
  }
  return localeMap[locale.value] || uiLocales.es
})

// Iniciar dia
const selectedDiaStore = useSelectedDayStore()
selectedDiaStore.init()

// Monedas: lista estática cacheada en Nitro; no bloquear SSR (lazy)
const currencies: Ref<Currency[]> = useState('currencies', () => [])
const { data: currenciesData } = useFetch<Currency[]>('/api-web/currencies', {
  key: 'currencies-list',
  lazy: true,
  default: () => [],
})
watch(currenciesData, (list) => {
  if (list?.length) {
    currencies.value = list
  }
}, { immediate: true })

// Iniciar Destino
const route = useRoute()
const selectedDestStore = useDestinationStore()
onMounted(async () => {
  await callOnce(async () => {
    selectedDestStore.initDestination(route)
  })
})

const siteUrl = computed(() => (runtimeConfig.public.BASE_URL || '').replace(/\/$/, ''))

useHead({
  htmlAttrs: {
    lang: locale,
  },
  script: computed(() => {
    if (!siteUrl.value) return []
    return [{
      key: 'site-jsonld',
      type: 'application/ld+json',
      innerHTML: toJsonLd({
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            name: 'BYHOURS',
            url: siteUrl.value,
            logo: DEFAULT_OG_IMAGE,
          },
          {
            '@type': 'WebSite',
            name: 'BYHOURS',
            url: siteUrl.value,
            inLanguage: [...PUBLIC_LOCALES],
          },
        ],
      }),
    }]
  }),
  link: [
    {
      rel: 'icon',
      href: '/favicon.ico'
    },
    {
      rel: 'preload',
      href: '/fonts/NHaasGroteskText.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: ''
    },
    {
      rel: 'preload',
      href: '/fonts/NHaasGroteskDisplay-bold.woff2',
      as: 'font',
      type: 'font/woff2',
      crossorigin: ''
    }
  ]
})
</script>

<template>
  <UApp :locale="uiLocale">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>